"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = void 0;
const react_1 = require("react");
const providers_1 = require("../providers");
const useModal = () => {
    const [state, dispatch] = react_1.useContext(providers_1.ModalContext);
    return [state, dispatch];
};
exports.useModal = useModal;
exports.default = exports.useModal;
